import { useState } from 'react';
import { useScreenStore } from '../stores/useScreenStore';
import { useCurrentScreen } from '../hooks/screen/useCurrentScreen';
import { useAuthGuard } from '../hooks/auth/useAuthGuard';
import { useOnboardingGuard } from '../hooks/auth/useOnboardingGuard';
import MonitorIcon from '@mui/icons-material/Monitor';
import CustomButtonSelector from '../components/CustomButtonSelector';

const SelecionarMonitores = () => {

  const [monitor, setMonitor] = useState(0);
  const setMonitorMode = useScreenStore(state => state.setMonitorMode);

  useCurrentScreen('Selecione o número de monitores');
  const { hasUser } = useAuthGuard();
  const { canRender } = useOnboardingGuard('monitor');

  if (!hasUser || !canRender) return null;

  return (
    <CustomButtonSelector
      title="Escolha o número de Telas"
      options={[
        { id: 1, label: '1 Tela', icon: <MonitorIcon /> },
        { id: 2, label: '2 Telas', icon: <><MonitorIcon fontSize="small" /><MonitorIcon fontSize="small" /></> },
      ]}
      selected={monitor}
      setSelected={setMonitor}
      onConfirm={() => setMonitorMode(monitor)}
      multiple={false}
    />
  );
};

export default SelecionarMonitores;